export enum ClaimStatus {
	PENDING = 'Pending',
	PROCESSING = 'Processing',
	IN_PROGRESS = 'In Progress',
	DENIED = 'Denied',
	APPROVED = 'Approved',
	DELETED = 'Deleted',
}

export type ArtistClaim = {
	id: number;
	createdAt: string;
	stakeholderType: 'Artist';
	name: string;
	imageHash: string;
	upc: string;
	status: ClaimStatus;
};

export type LabelClaim = {
	id: number;
	createdAt: string;
	stakeholderType: 'Label';
	subLabels: {
		id: number;
		name: string;
		providerName: string;
		upc: string;
	}[];
	type: 'Create';
	status: ClaimStatus;
};

export type ManagerArtistInfo = {
	name: string;
	artistId: number;
	imageHash: string;
	upc: string;
};

export type ManagerClaim = {
	id: number;
	createdAt: string;
	stakeholderType: 'Manager';
	artists: ManagerArtistInfo[];
	type: 'Create';
	status: ClaimStatus;
};

export type ProviderClaim = {
	id: number;
	createdAt: string;
	name: string;
	stakeholderType: 'Provider';
	upc: string;
	status: ClaimStatus;
};

export type PostClaim = {
	data: null | string | {message: string};
	errors?: {status: string; title: string; code: string; detail: string}[];
};

export type Claim = ArtistClaim | LabelClaim | ManagerClaim | ProviderClaim;

export type ClaimResponse = {
	data: Claim[];
};
